import { render } from "./ThongBao.vue?vue&type=template&id=22dbea6c"
import script from "./ThongBao.vue?vue&type=script&lang=js"
export * from "./ThongBao.vue?vue&type=script&lang=js"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__